import React, { Component } from "react";
import SignUp from "components/Buttons/SignUp";

import wirelessLight from "./images/wirelessLite.png";
import wirelessPro from "./images/wirelessPro.png";

class ReaderCompare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pro: props.pro ? props.pro : "R2349",
      lite: props.lite ? props.lite : "R1799"
    };
  }
  render() {
    return (
      <section className=" d-md-none" style={{ background: "#F6F6F6" }}>
        <div className="bg-lightGrey pt-5 hidden-xs">
          <div className="container marketingSection">
            <div
              className="row align-items-center"
              style={{ marginBottom: "200px" }}
            >
              <div className="col-md-12 text-center">
                <h2>CARD READERS</h2>
                <h3>
                  Choose the one that's right for <br className="hide" />your
                  business
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-lightGrey readersSideBySide">
          <div className="container marketingSection">
            <div className="row align-items-center">
              <div className="col-md-1" />
              <div className="col-md-5 text-center">
                <img
                  style={{ marginTop: "-200px" }}
                  src={wirelessPro}
                  className="img-fluid"
                  alt="Yoco Wireless Pro card reader"
                  width="100%"
                />
                <br />
                <br />
                <h3>Wireless Pro</h3>
                <p style={{ padding: "0 20px" }}>
                  With its all day battery life the Wireless Pro is perfect for
                  any buzzing business. Accept swipe, chip and PIN cards and add
                  a range of hardware for a professional look. Compatible with
                  Android and Apple devices.
                </p>
                <p>
                  <SignUp
                    text={`Order today for ${this.state.pro}`}
                    className="signupLrg"
                  />
                </p>
                <p className="tiny">
                  Weekly payments are available.<br />
                </p>
                <br />
              </div>
              <div className="col-md-5 text-center">
                <img
                  style={{ marginTop: "-200px" }}
                  src={wirelessLight}
                  className="img-fluid"
                  alt="Yoco Wireless Lite card reader"
                  width="100%"
                />
                <br />
                <br />
                <h3>Wireless Lite</h3>
                <p style={{ padding: "0 20px" }}>
                  With its all day battery life, the Wireless Lite is perfect
                  for any pop-up, in-store or on-the-go business. Start
                  accepting swipe, chip and PIN cards like thousands of other
                  Yoco merchants. Compatible with Android and Apple devices.
                </p>
                <p>
                  <SignUp
                    text={`Order today for ${this.state.lite}`}
                    className="signupLrg"
                  />
                </p>
                <p className="tiny">
                  Weekly payments are available.<br />
                </p>{" "}
                <br />
              </div>
              <div className="col-md-1" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ReaderCompare;



// WEBPACK FOOTER //
// ./src/sections/signupPage/readerCompare/index.js